import useIsMobile from 'hooks/useIsMobile';

export type PdfLinks = {
  mobile: string;
  desktop: string;
};

export default function useResponsivePdfLink({
  desktop,
  mobile,
}: PdfLinks): string {
  const isMobile = useIsMobile();

  if (isMobile) return `/${mobile}.pdf`;
  return `/${desktop}.pdf`;
}
